import { reduce } from 'lodash-es';

/**
 * // Should turn /{key}/something into /value/something with params: { key: 'value' }
 * @param path
 * @param params
 */
export const interpolatePath = (
  path: string,
  params: Record<string, string>
): string => {
  return reduce(
    params,
    (templatedUrl: string, value: string, key: string) => {
      return templatedUrl.replace(`{${key}}`, value);
    },
    path
  );
};



// WEBPACK FOOTER //
// ./src/utils/PathInterpolation.ts